import React, { useContext } from 'react';
import {
     CCard,
     CCardBody,
     CButton,
     CRow,
     CCol,
     CCardHeader,
} from '@coreui/react';
import { FormSetupContext } from '../FormSetup';

const RULE_TYPE = {
     ENRICHMENT_RULE: 'Enrichment Rule',
     SUPPRESSION_RULE: 'Suppression Rule',
};

const RuleType = () => {
     const { activeStep, setActiveStep, stepsData, setStepsData, isPixelRule } = useContext(FormSetupContext);
     const { ruleType, id } = stepsData;
     const handleSelectRule = (ruleType) => {
          setStepsData({
               ...stepsData,
               ruleType,
               conditions: [
                    {
                         conjunction: '',
                         g0: {
                              type: 'Conversion',
                              key: '',
                              operator: 'eq',
                              value: 'true',
                              conjunction: '',
                              enrichmentType: '',
                         },
                    },
               ]
          });
          setActiveStep(2);
     }

     return (
          <>
               {
                    <CCard className={`cvr-step-1 ${activeStep !== 1 ? 'difference-step' : 'cvr-step-card'}`}>
                         <CCardHeader>
                              {activeStep !== 1 ? (
                                   <div className="rule-step d-inline-flex justify-content-between align-items-center w-100">
                                        <h5 className="mb-0 inactive">Step 1: Rule Type</h5>
                                        <div className="d-inline-flex align-items-center">
                                             <h5 className='mr-3'>{ruleType}</h5>
                                             {!id && !isPixelRule && (
                                                  <CButton className="btn-edit" onClick={() => setActiveStep(1)}>
                                                       Edit
                                                  </CButton>
                                             )}
                                        </div>


                                   </div>
                              ) : (
                                   <h5>Step 1: Select rule type</h5>

                              )}
                         </CCardHeader>
                         {
                              activeStep === 1 && (
                                   <CCardBody>
                                        <div className="rule-step">
                                             <CRow className="mb-3">
                                                  <CCol>
                                                       <div className='d-flex align-items-center'>
                                                            <CButton
                                                                 className=" f-13 mr-5"
                                                                 color={ruleType === RULE_TYPE.ENRICHMENT_RULE ? "primary" : "dark"}
                                                                 onClick={() => handleSelectRule(RULE_TYPE.ENRICHMENT_RULE)}
                                                            >
                                                                 {RULE_TYPE.ENRICHMENT_RULE}
                                                            </CButton>
                                                            <p>Enter multiple conditions and define a few variables values as a result.</p>
                                                       </div>
                                                  </CCol>
                                             </CRow>
                                             <CRow className="mb-3">
                                                  <CCol>
                                                       <div className='d-flex align-items-center'>
                                                            <CButton
                                                                 className=" f-13 mr-5"
                                                                 color={ruleType === RULE_TYPE.SUPPRESSION_RULE ? "primary" : "dark"}
                                                                 onClick={() => handleSelectRule(RULE_TYPE.SUPPRESSION_RULE)}
                                                            >
                                                                 {RULE_TYPE.SUPPRESSION_RULE}
                                                            </CButton>
                                                            <p>Use a table to manage a large list of variable values based on one or many conditions.</p>
                                                       </div>
                                                  </CCol>
                                             </CRow>
                                        </div>
                                   </CCardBody>
                              )
                         }
                    </CCard>
               }
          </>
     )
}

export default RuleType
